import {ID, Resource} from 'simpli-web-sdk'
import DeliveryAlertHistoryResponseSchema from '@/schema/DeliveryAlertHistoryResponse.schema'
import Motorista from '@/model/resource/Motorista'

export default class DeliveryAlertHistoryResponse extends Resource {

  readonly $name: string = 'DeliveryAlertHistoryResponse'
  readonly $endpoint: string = '/user/indicador/historico-alerta'

  get $id() {
    return this.id
  }
  set $id(val: ID) {
    this.id = val
  }

  get $schema() {
    return DeliveryAlertHistoryResponseSchema(this)
  }

  id: ID = 0
  mensagem: string | null = null
  documento: string | null  = null
  motorista: Motorista | null  = null
  data: string | null = null

}
